module.exports = __webpack_public_path__ + "img/u57.cc077262.svg";